import { z } from 'zod';
// Stops Zod's new Function('') eval probe, which the CSP blocks and reports to Sentry
z.config({ jitless: true });
